import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Endpoints } from '../../api';
import { AppThunk, RootState } from '../store';
import { deleteDataWithBody, postData } from '../thunks/itemsApi';

export interface chatContacts {
    value: Array<any>;
    status: 'idle' | 'loading' | 'failed';
}

const initialState: chatContacts = {
    value: [],
    status: 'idle'
};

export const fetchContacts = createAsyncThunk('contacts', async (data: any) => {
    const request = {
        body: {
            userId: data?.userId
        },
        lang: data?.lang
    };

    const response = await postData(Endpoints.chatUrl + '/home/contacts', request);
    return response;
});

export const deleteRoom = createAsyncThunk('contacts/deleteRoom', async (payload: { userId: number; roomId: number }) => {
    const response = await deleteDataWithBody(Endpoints.chatUrl + '/Home/DeleteRoom', {
        userId: payload.userId,
        roomId: payload.roomId
    });
    return { ...payload, response };
});

export const contactSlice = createSlice({
    name: 'contacts',
    initialState,
    reducers: {
        setContacts: (state, action: PayloadAction<Array<any>>) => {
            state.value = action.payload;
        },
        clearContacts: (state) => {
            state.value = [];
        },
        removeContactByRoomId: (state, action: PayloadAction<number>) => {
            state.value = state.value.filter((c: any) => c.chat_room_id !== action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchContacts.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchContacts.fulfilled, (state, action) => {
                state.status = 'idle';
                state.value = action.payload?.data ?? action.payload ?? [];
            })
            .addCase(deleteRoom.fulfilled, (state, action) => {
                state.value = state.value.filter((c: any) => c.chat_room_id !== action.meta.arg.roomId);
            });
    }
});

export const { setContacts, clearContacts, removeContactByRoomId } = contactSlice.actions;

export const selectContacts = (state: RootState) => state.chatContacts.value;
export const selectContactsLoading = (state: RootState) => state.chatContacts.status;

export default contactSlice.reducer;

export const fetchContactsAsync =
    (data: any): AppThunk =>
    async (dispatch) => {
        try {
            dispatch(fetchContacts(data));
        } catch (err) {
            console.error(err);
        }
    };
